document.addEventListener("DOMContentLoaded", function () {
  var confirmPageUrl = "pages/boost-confirm";
  var btn = document.getElementById("confirmBuyBtn");
  var sizeInputs = document.querySelectorAll('input[name="tee-size"]');
  var sizeError = document.getElementById("sizeError");

  function getSelectedSize() {
    for (var i = 0; i < sizeInputs.length; i++) {
      if (sizeInputs[i].checked) return sizeInputs[i].value;
    }
    return "";
  }

  function updateButtonHref() {
    var selectedSize = getSelectedSize();
    if (!selectedSize) {
      btn.setAttribute("href", "#");
      btn.setAttribute("aria-disabled", "true");
      return;
    }

    var currentParams = new URLSearchParams(window.location.search);
    currentParams.set("response", selectedSize); 

    var target = new URL(confirmPageUrl, window.location.origin);
    var targetParams = new URLSearchParams(target.search);

    currentParams.forEach(function (value, key) {
      targetParams.set(key, value);
    });

    target.search = targetParams.toString();
    btn.setAttribute("href", target.toString());
    btn.setAttribute("aria-disabled", "false");
  }

  for (var i = 0; i < sizeInputs.length; i++) {
    sizeInputs[i].addEventListener("change", function () {
      sizeError.style.display = "none";
      updateButtonHref();
    });
  }

  btn.addEventListener("click", function (e) {
    if (!getSelectedSize()) {
      e.preventDefault();
      sizeError.style.display = "block";
    }
  });

  updateButtonHref();
});